export const PRODUCT_COUNT_TEXT = 'left_rail.product_count_text';
export const PRODUCT_COUNT_ARIA_LABEL = 'left_rail.product_count_aria_label';
export const ITEM_COUNT_TEXT = 'left_rail.item_count_text';
export const ITEM_COUNT_ARIA_LABEL = 'left_rail.item_count_aria_label';
export const CLEAR_ALL_TEXT = 'mobile_facets_wrapper.clear_all_text';
export const DONE_TEXT = 'mobile_facets_wrapper.done_text';
export const FILTER_BUTTON = 'left_rail_lhf.filter_button';
export const CLEAR_FILTER_BUTTON = 'left_rail_lhf.clear_filter_button';
export const PRODUCT_FIlTERS ='left_rail_lhf.product-filters';
export const MODELS_TEXT = 'dashboard.model' ;
export const SORT_BY_TEXT = 'dashboard.sort_by';
